module.exports = __webpack_public_path__ + "media/AUDIO 07.2905fa66.mp3";